import { Navigate, Outlet } from "react-router-dom";

import { useGetOrganization } from "@/hooks/api/organization/useGetOrganization";
import { OrganizationType } from "@/types/organization";

type OrganizationTypeRouteProps =
  | { allowedType: OrganizationType; excludedType?: never }
  | { excludedType: OrganizationType; allowedType?: never };

export const OrganizationTypeRoute = ({
  allowedType,
  excludedType,
}: OrganizationTypeRouteProps) => {
  const { data: organization, isLoading } = useGetOrganization();

  if (isLoading) {
    return null;
  }

  const isBlocked = allowedType
    ? organization?.type !== allowedType
    : organization?.type === excludedType;

  if (!import.meta.env.DEV && isBlocked) {
    return <Navigate replace to="/dashboard" />;
  }

  return <Outlet />;
};
